import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnSliderTemplateOptions } from './slider-template-options.interface';

export interface ISnSliderFormFieldConfig extends FormlyFieldConfig {
  type: 'slider';
  templateOptions?: ISnSliderTemplateOptions;
}
